import React from 'react';

export default ({ handleSortClick, order, sortedBy }) => {
  function createClasses(key) {
    if (sortedBy === key) return `${order ? 'asc' : 'desc'} active`;
    return '';
  }

  return (
    <div className='list-scene__table-header'>
      <div
        className={`list-scene__table-header-element ${createClasses(
          'fileName'
        )} list-scene__table-row-element_place_filler`}
        onClick={handleSortClick('fileName')}
      >
        <div>Document Name</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('type')} _width_pc_22`}
        onClick={handleSortClick('type')}
      >
        <div>Document Type</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('date')} _width_pc_12`}
        onClick={handleSortClick('date')}
      >
        <div>Document Date</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('status')} _width_pc_12`}
        onClick={handleSortClick('status')}
      >
        <div>Status</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div className='list-scene__table-header-element _text_align_center _jc_center _width_pc_12'>
        <div>Download</div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/DocumentsList/TableHeader.jsx